module.exports = __webpack_public_path__ + "static/media/5555.5dcefab8.png";